import { swarmRequest } from '@common/helpers/util/requestMiddleware';

const WITHDRAW_V1_SERVICE = '20112';

class WithdrawalCommands {
  // ---- v1 (legacy `withdraw` form-based flow) ---------------------------

  static getBetshopListV1() {
    return swarmRequest({
      amount: 0,
      payee: { getWallets: 1 },
      service: WITHDRAW_V1_SERVICE,
    }, 'withdraw');
  }

  static cashWithdrawalRequestV1(amount, shopId) {
    return swarmRequest(
      {
        amount,
        service: WITHDRAW_V1_SERVICE,
        payee: {
          stage: 'pay',
          shopId,
          confirmation_code: '',
        },
      },
      'withdraw',
    );
  }

  // ---- v2 (current default flow) ---------------------------------------

  static getBetshopListV2() {
    return swarmRequest({}, 'get_bet_shops');
  }

  static cashWithdrawalRequestV2(amount, officeId) {
    return swarmRequest(
      {
        amount,
        service: 353,
        payee: { forProduct: 'sport', isAmountHidden: false, office_id: officeId },
      },
      'withdraw_v2',
    );
  }

  // ---- unchanged ------------------------------------------------------

  static getClientBalance() {
    return swarmRequest({ product: 'Sport' }, 'get_client_withdrawable_balance');
  }

  static getWithdrawalHistory(start, end) {
    return swarmRequest({ where: { type: 1, from_date: start, to_date: end } }, 'balance_history_v2');
  }
}
export default WithdrawalCommands;
